module.exports = __webpack_public_path__ + "media/images/talent/lp/ambassador/title01-a324d35f9255a8f1eb287ef02c7bbf1b.svg";